import { Addchart } from '@mui/icons-material';
import i18n from 'i18next';

const getMasterDataManagement = () => ({
  id: 'masterDataManagement',
  type: 'group',
  children: [
    {
      id: 'masterDataManagement',
      title: i18n.t('sidemenu.masterDataManagement'),
      type: 'item',
      url: '/masterDataManagement',
      icon: Addchart,
      breadcrumbs: false,
    },
  ]
});

export default getMasterDataManagement;